/**
 * 权限控制指令
 * 使用方式：
 * v-permission="'customer:dataSetting'" - 单个权限
 * v-permission="['customer:dataSetting', 'customer:rollback']" - 多个权限（需要全部拥有）
 * v-permission.any="['customer:dataSetting', 'customer:rollback']" - 多个权限（拥有任意一个即可）
 */
import storage from '@/utils/storage'

/**
 * 检查是否有权限
 * @param {String|Array} permissions - 需要的权限，可以是字符串或数组
 * @param {Boolean} requireAll - 如果是数组，true表示需要全部权限，false表示任意一个即可
 * @returns {Boolean} 是否有权限
 */
function checkPermission(permissions, requireAll = true) {
  const userPermissions = storage.get('permissions') || []
  
  if (!userPermissions || userPermissions.length === 0) {
    return false
  }

  // 如果是字符串，转换为数组
  if (typeof permissions === 'string') {
    permissions = [permissions]
  }

  // 如果不是数组，返回false
  if (!Array.isArray(permissions)) {
    return false
  }

  if (requireAll) {
    // 需要全部权限
    return permissions.every(permission => userPermissions.includes(permission))
  } else {
    // 只需要任意一个权限
    return permissions.some(permission => userPermissions.includes(permission))
  }
}

/**
 * 权限指令
 */
const permission = {
  inserted(el, binding) {
    const { value, modifiers } = binding
    const requireAll = !modifiers.any // 如果没有 .any 修饰符，则默认需要全部权限

    if (!value) {
      // 如果没有传入权限值，默认隐藏
      el.style.display = 'none'
      return
    }

    const hasPermission = checkPermission(value, requireAll)

    if (!hasPermission) {
      // 没有权限，隐藏元素
      el.style.display = 'none'
    } else {
      // 有权限，显示元素
      el.style.display = ''
    }
  },
  update(el, binding) {
    const { value, modifiers } = binding
    const requireAll = !modifiers.any

    if (!value) {
      el.style.display = 'none'
      return
    }

    const hasPermission = checkPermission(value, requireAll)

    if (!hasPermission) {
      // 没有权限，隐藏元素
      el.style.display = 'none'
    } else {
      // 有权限，显示元素
      el.style.display = ''
    }
  }
}

/**
 * Vue 插件安装函数
 */
const install = Vue => {
  // 注册指令
  Vue.directive('permission', permission)
  
  // 同时提供一个方法供组件内使用
  Vue.prototype.$hasPermission = function(permissions, requireAll = true) {
    return checkPermission(permissions, requireAll)
  }
}

export default {
  install,
  checkPermission
}

